export class Candidate {
    UserId;
    FullName;

    constructor(fullName, userId) {
        this.UserId = userId;
        this.FullName = fullName;
    }
}